export const gamecode = {
    rolesCanShowBannerInfo: ['administrator', 'manager', 'director', 'trainer', 'learner'],
}